import './CreditCardInitialInfoSection.scss';

// @ vendors
import React, { Component } from 'react';
import { connect } from 'react-redux';

// @ utilities
import { formatText } from 'core/i18n';

//@ icons
import CreditCardFeaturesInfo from 'components/CreditCardComponents/CreditCardInitialSection/CreditCardInitialInfoSection/CreditCardFeaturesInfo/CreditCardFeaturesInfo';
import { BASIC as PARTNER_BASIC } from 'constants/creditCard/partners';
import { getCreditCardImage } from 'utilities/creditCard/creditCard';

const THEME1 = 'theme1';
const THEME2 = 'theme2';
const THEME3 = 'theme3';
class CreditCardInitialInfoSection extends Component {
    getTheme(theme) {
        switch (theme) {
            case '2':
                return THEME2;
            case '3':
                return THEME3;
            case '1':
            default:
                return THEME1;
        }
    }

    render() {
        const { partner } = this.props;
        const creditCardImage = getCreditCardImage(partner ? partner.get('id') : PARTNER_BASIC);
        const theme = this.getTheme(partner.get('theme'));

        return (
            <div className={`container tc-section ${theme}`}>
                <div className="row">
                    <div className="col-md-6 col-sm-10 col-xs-12">
                        <div className="tc-section-desc">
                            <div className="tc-section-desc-label">
                                {formatText(`initialInfoSection-descriptionLabel_${partner.get('id')}`)}
                            </div>
                            <div className="tc-section-desc-title">
                                {formatText(`initialInfoSection-descriptionTitle_${partner.get('id')}`)}
                            </div>
                            <CreditCardFeaturesInfo />
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <div className="cart-art">
                            <img src={creditCardImage} className={`tc-section-${theme}-card-art`} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    userProfile: state.userProfile,
    partner: state.products.get('partner'),
}))(CreditCardInitialInfoSection);
